import { render, staticRenderFns } from "./Science and technology sector.vue?vue&type=template&id=7c581565&scoped=true&"
import script from "./Science and technology sector.vue?vue&type=script&lang=js&"
export * from "./Science and technology sector.vue?vue&type=script&lang=js&"
import style0 from "./Science and technology sector.vue?vue&type=style&index=0&id=7c581565&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c581565",
  null
  
)

export default component.exports